import cn from 'classnames';
import React, { FC, memo } from 'react';

import { AvatarGroup } from '@mui/material';

import { TokenSize } from '@constants/common/ui.constants';

import { TokenIconItem } from '@app-types/common/token.types';

import TokenIcon from './TokenIcon';
import useStyles from './styles.module';

interface Props {
  tokens: TokenIconItem[];
  className?: string;
  size?: TokenSize;
}

const TokensIcon: FC<Props> = ({
  className = '',
  tokens,
  size = TokenSize.Small,
}) => {
  const { classes } = useStyles();

  return (
    <AvatarGroup className={cn(classes.avatarGroup, className)}>
      {tokens.map((token) => (
        <TokenIcon
          {...token}
          size={size}
          key={`${token.address}_${token.chainId}`}
        />
      ))}
    </AvatarGroup>
  );
};

export default memo(TokensIcon);
